// extracted by mini-css-extract-plugin
export default {"holder":"Loader_holder__Nu4lF","loader-circle":"Loader_loader-circle__WK8Yi"};